module.exports = __webpack_public_path__ + "static/img/peekaboo.855589e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/peekaboo.jpg
// module id = kbeO
// module chunks = 1